<section class="auth-layout">

  <!-- E-commerce Background Image -->
  <div class="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-15 "
    style="background-image: url('images/bg/bg_ecommerce.png');">
  </div>

  <!-- Background Grid -->
  <!-- <div class="absolute inset-0 opacity-10">
    <div class="grid-bg w-full h-full"></div>
  </div> -->

  <!-- Animated Rings -->
  <!-- <div
    class="absolute w-[400px] h-[400px] lg:w-[700px] lg:h-[700px] border-4 border-primary-500 rounded-full animate-spin-slow opacity-20 -top-[200px] -left-[200px]">
  </div>
  <div
    class="absolute w-[300px] h-[300px] lg:w-[500px] lg:h-[500px] border-2 border-primary-400 rounded-full animate-spin-slower opacity-20 -bottom-[150px] -right-[150px]">
  </div> -->

  <!-- Lock Icon Background -->
  <!-- <div class="absolute inset-0 flex items-center justify-center opacity-5">
    <span class="iconify text-[300px] lg:text-[500px] text-primary-500" data-icon="mdi:shield-lock-outline"></span>
  </div> -->

  <!-- Content Wrapper -->
  <div class="relative w-full z-10">
    <router-outlet></router-outlet>
  </div>

</section>